// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (min-width: 769px) {\n#inactive__toast_outer {\n    top: 60px !important;\n}\n.b-toaster-slot.vue-portal-target:has(#inactive__toast_outer) {\n    left: 250px !important;\n}\n}\n.toast#inactive {\n  max-width: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
